import { watchEffect } from "vue";
import { userInfos } from "@/state/api/userState";
import { featuresMap } from "@/state/api/featuresState";
import { isEmpty } from "lodash";

export default (type: string, values: Array<string>) => {
	let access = false;

	// Root users have unrestricted access to all resources and permissions
	if (userInfos.value?.roles?.some((role: any) => role.name === "Root" || role.id === 4)) {
		return true;
	}

	// Enterprise Admin has full access to every resource/permission within
	// their own enterprise, mirroring the backend bypass (CheckPermission +
	// UserPolicy/UserRolePolicy). Scoped to the "resource"/"permission" axes
	// only: role-name "visibility" checks stay intact so Root-only cards and
	// menu entries remain hidden from the Admin.
	if (
		(type === "resource" || type === "permission") &&
		userInfos.value?.roles?.some((role: any) => role.name === "Admin")
	) {
		return true;
	}

	switch (type) {
		case "visibility":
			watchEffect(() => {
				if (isEmpty(userInfos.value) === false) {
					const roles = userInfos.value?.roles;
					for (const role of roles) {
						if (values.includes(role.name)) {
							access = true;
							break;
						}
						access = false;
					}
				}
			});
			break;
		case "permission":
			watchEffect(() => {
				if (isEmpty(userInfos.value) === false) {
					const permissions = userInfos.value?.permissions;
					for (const permission of permissions) {

					if (values.includes(permission.name)) {
						access = true;
						break;
					}
					access = false;
				}
			}
		});
		break;
		case "resource":
			watchEffect(() => {
				if (isEmpty(userInfos.value) === false) {
					const permissions = userInfos.value?.permissions;
					for (const permission of permissions) {
						if (values.includes(permission.resource)) {
							access = true;
							break;
						} else if (values.includes("all")) {
							access = true;
							break;
						}
						access = false;
					}
				}
			});
			break;
		case "stationBelongTo":
			watchEffect(() => {
				if (isEmpty(userInfos.value) === false) {
					const stations = userInfos.value?.stations;
					values = values.map(String); // forcer la conversion en chaine de nombre/caracteres
					for (const station of stations) {
						if (values.includes(station.id.toString())) {
							access = true;
							break;
						}
						access = false;
					}
				}
			});
			break;
		case "subscription":
			watchEffect(() => {
				if (isEmpty(userInfos.value) === false) {
					const entry = featuresMap.value?.["param.subscription.active"];
					// Default to true if not configured (backward compatible).
					access = entry !== undefined ? !!entry.enabled : true;
				}
			});
			break;

		case "payment":
			watchEffect(() => {
				if (isEmpty(userInfos.value) === false) {
					const entry = featuresMap.value?.["param.subscription.payment_valid"];
					// Default to true if not configured (backward compatible).
					access = entry !== undefined ? !!entry.enabled : true;
				}
			});
			break;
		default:
			break;
	}
	return access;
};


